/**
 * RivalryMessagesTab — iter87.6. Dedicated Rivalry-Admin tile for the
 * crew-wide messages feature (posts crewmates see on the dashboard
 * "Smack Stream & Updates" section). Pulled out of Rivalry Settings so
 * message composition and message admin controls each have their own
 * clear surface.
 *
 * iter87.199.190 — `InviteTextCopyCard` is now rivalry-level (no
 * tournament dependency — see its own docstring) so it always renders,
 * not just when a tournament is loaded. `RivalryLinkCopyCard` sits
 * right below it for the "already registered" audience.
 */
import LeagueMessagesCard from "@/components/LeagueMessagesCard";
import SmackStreamAdminToggleCard from "@/components/SmackStreamAdminToggleCard";
import InviteTextCopyCard from "@/components/admin/InviteTextCopyCard";
import RivalryLinkCopyCard from "@/components/admin/RivalryLinkCopyCard";

export default function RivalryMessagesTab({ league, leagueId, tournament, isLocked, onChanged }) {
    return (
        <div className="space-y-5" data-testid="rivalry-messages-tab">
            <div className="brutal-card-light p-3 flex items-start gap-3">
                <p className="text-xs text-zinc-300 leading-relaxed">
                    <strong className="text-cyber">Broadcast to the crew.</strong> Announcements post to every crewmate's
                    dashboard Smack Stream & Updates section. Below, toggle whether crewmates can also post to the Smack Stream.
                </p>
            </div>
            <LeagueMessagesCard leagueId={leagueId} isLocked={isLocked} />
            <InviteTextCopyCard />
            <RivalryLinkCopyCard leagueId={leagueId} />
            <SmackStreamAdminToggleCard league={league} leagueId={leagueId} isLocked={isLocked} onChanged={onChanged} />
        </div>
    );
}

